import { api } from "assets/scripts/utilities/api-clients";

const prepareCreditRatings = (ratings) => {
  return ratings.reduce((acc, item) => {
    const { agency, ...rest } = item;

    if (!acc[agency]) {
      acc[agency] = [];
    }

    acc[agency].push({ agency, ...rest });

    return acc;
  }, {});
};

export const index = async () => {
  const response = await api.get(`/kam/crisil`);
  const creditRatings = prepareCreditRatings(response.data?.data);

  return creditRatings;
};
